<template>
  <div class="inteBox">
    <intNavheaderHealth activeNameCheck="second"></intNavheaderHealth>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div class="titleTopCenterLeftBoxno">添加签约</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <!-- <div @click="goBack"> <i class="el-icon-back"></i>返回</div>
           <span style="margin: 0 10px;">|</span>  -->
          <div class="Content1Title">请选择人物/家庭进行签约</div>
        </div>
        <div class="doCboxH" style="background-color: #ffffff;padding-left:40px">
            <el-input placeholder="请输入内容" v-model="keyWord" style="width:40%;background-color: #ffffff">
                <el-button slot="append"  type="primary" @click="searchHospitals" >搜索</el-button>
            </el-input>
            <div class="titleTopCenterCenterBtn">
                <el-button size="small" type="warning" @click="goHosDetail(1)">家庭签约</el-button>
                <el-button size="small" icon="el-icon-plus" type="primary" @click="goHosDetail(0)">个人签约</el-button>
                <el-button size="small"  type="warning" @click="goIndex" style="background-color: #409eff;border-color: #409eff;">返回首页</el-button>
            </div>
        </div>
 
        <div style="background: #ffffff;min-height:80vh;padding:0 40px">
            <div class="doCboxList">
                <div :class="famIndex == index ? 'doCboxChecked' : 'doCbox'" v-for="(item,index) in hosList" :key="index" @click="goChoosfam(item,index)">
                    <div class="doCboxH" style="align-items: flex-start;">
                        <div class="doCboxImg">
                            <img v-if="item.imagePath " :src="CommonPath + item.imagePath">
                            <img v-else src="../../assets/img/reservation/touxiang03.png" alt="">
                        </div>
                        <div style="flex: 1; width: calc(100% - 70px);margin-left: 10px;">
                            <div class="doCboxH"  style="align-items: flex-start;">
                                <div>
                                    <div style="font-weight: bold;font-size: 18px;color: #333333;display: flex;align-items: center;">
                                        <span class="gHDocRightTitle">{{item.name}}</span>
                                        <span class="docTagNameCheck" v-if="item.isRealName">已实名</span>
                                        <span class="docTagNameNo" v-if="!item.isRealName">未实名</span>
                                    </div>
                                    <div class="des">
                                        <span>{{item.sex == 0 ? '女' : '男'}}</span> 
                                        <span style="margin: 0 10px;">|</span> 
                                        <span>{{item.age}}</span> 
                                        <span style="margin: 0 10px;">|</span> 
                                        <span>{{item.phone}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="doCboxH">
                                <div class="des">
                                    <i class="el-icon-s-home" style="margin-right: 10px;"></i>{{item.familyName}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="hosList.length == 0" style="margin:50px auto; display: flex;align-items: center;flex-direction: column;">
                    <img src="../../assets/img/reservation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                    <span style="color: #666666;">暂无数据！</span>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
  </div>
</template>
<script>
import intNavheaderHealth from "../../components/intNavheaderHealth";
import { healthRecord } from "../../components/healthRecord/healthRecord";
export default {
  components: {
    intNavheaderHealth,
  },
  data() {
    var healthRecordData = new healthRecord(
      this.TokenClient,
      this.Services.Authorization
    );
    return {
        healthRecordDomain: healthRecordData,
        userInfo: this.$store.state.localData.userInfo,
        hosList:[],
        keyWord:'',
        http:'',
        cityList:'',
        famIndex:-1,
        famindexDetail:{},
        healthRecordData:{},
    };
  },
  methods: {
    goChoosfam(e,index){
        console.log(e)
        this.famIndex = index
        this.famindexDetail = e
    },
    searchHospitals(){
        this.GetHealthRecordOrganizationList()
    },
    GetHealthRecordOrganizationList() {
      var _this = this
      let orgKeyWord = _this.keyWord == '' ? '%20' : _this.keyWord
      _this.healthRecordDomain.GetHealthRecordNotSignUserInfo(
        orgKeyWord,
        function (data) {
          _this.hosList = data.data;
        },
        function (error) {
          console.log(error);
          _this.hosList = [];
        }
      );
    },
    goHosDetail(e) {
        if (this.famIndex == -1) {
            this.$message({
                message: '请选择一条数据',
                type: 'warning'
            });
            return
        }
        this.$confirm('是否确认签约?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.goNextDes(e)
        }).catch(() => {
                 
        });
        return
        this.$router.push({
            name: "signingApplyUserDetail",
            query: {
              id: this.famindexDetail.healthRecordId,
              type: e,
              healthRecordFamilyId: this.famindexDetail.healthRecordFamilyId,
            },
        });
    },
    goNextDes(e){
				let params =[
					{
						signDoctorId:this.userInfo.id,
						signDoctorType:this.userInfo.doctorHealthManagerType,
						organizationId:this.userInfo.organizationId,
						signApplyType:1,
						signFamilyType:e,
						healthRecordId:this.famindexDetail.healthRecordId,
						healthRecordFamilyId:this.famindexDetail.healthRecordFamilyId
						// signFile:this.auditSignImg
					}
				]
				this.healthRecordData.healthRecordId = this.famindexDetail.healthRecordId
				this.healthRecordData.healthRecordFamilyId = this.famindexDetail.healthRecordFamilyId
				this.healthRecordData.healthRecordSignAttas = params
        var _this = this
        _this.healthRecordDomain.AddHealthRecordSign(
            _this.healthRecordData,
            function (data) {
              _this.$message({
                  message: '提交成功',
                  type: 'success'
              });
              _this.$router.push({
                name: "signingApplyList",
              });
            },
            function (error) {
            console.log(error);
            }
        );
		},
    goBack() {
      this.$router.go(-1);
    },
    goIndex(){
        this.$router.push({
            name: "index",
        });
    }
  },
};
</script>
<style scoped>
.pageBox {
  text-align: center;
  margin-top: 10px;
}
.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}
.titleTopLine {
  width: 100%;
  height: 12px;
}
.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}
.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  padding-top: 20px;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 10px auto;
  cursor: pointer;
  margin-bottom: 20px;
  /* margin-top: 0; */
}
.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #ffffff;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 10px auto;
  cursor: pointer;
  background: #06add7;
  margin-bottom: 20px;
  /* margin-top: 0; */
}
.titleTopCenterCenter {
  width: 83%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}
.titleTopCenterCenterTop {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 10px 40px;
  padding-top: 30px;
}
.titleTopCenterCenterBtn{
  padding: 10px 40px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.flex-l {
  display: flex;
  align-items: center;
}
.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Content1Title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 0;
}
::v-deep .el-pagination {
  padding: 10px 5px;
}
.el-page-header {
  line-height: 73px;
  /* padding-left: 20px; */
}
	.doCboxList {
        background: #ffffff;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
	}
	.doCbox {
		background: #F5FAF9;
		border-radius: 8px;
		padding: 30px;
		margin: 20px 0;
        width: 45%;
	}
	.doCboxChecked {
         width: 45%;
		background: linear-gradient(90deg, #EBFFFF, #FFFFFF);
		border-radius: 8px;
		border: 1px solid #00AFB5;
		padding: 30px;
		margin: 20px 0;
	}
	.doCboxImg {
		width: 64px;
		height: 64px;
	}
	.doCboxImg img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	.doCboxH {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.doCboxHF {
		display: flex;
		align-items: center;
	}
    .gHDocRightTitle {
		font-weight: bold;
		font-size: 18px;
		color: #333333;
		max-width: 200px;
		overflow: hidden;/*超出部分隐藏*/
		white-space: nowrap;/*不换行*/
		text-overflow:ellipsis;/*超出部分文字以...显示*/
		margin-right: 4px;
	}
    .docTag {
		font-size: 12px;
		color: #FFFFFF;
		background: #00AFB5;
		border-radius: 3px;
		padding: 2px 5px;
		margin-left: 5px;
	}
	.docHealthTag {
		font-size: 12px;
		color: #FFFFFF;
		background: #4194E7;
		border-radius: 3px;
		padding: 2px 5px;
		margin-left: 5px;
	}
    .docTagNameCheck {
		font-size: 12px;
		background: #DEF6F6;
		color: #00AFB5;
		border-radius: 3px;
		padding: 2px 5px;
		margin-left: 5px;
	}
	.docTagNameNo {
		font-size: 12px;
		background: #E2E5E7;
		border-radius: 6px;
		color: #666666;
		padding: 5px 10px;
		margin-left: 10px;
	}
    .des {
		color: #333333;
        font-size: 14px;
	}
    .doCboxBtn {
		display: flex;
		align-items: center;
        font-size: 16px;
        color: #333333;
	}
    .numTag2 {
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border-radius: 40px;
		font-size: 20px;
		background-color: #E63838;
		color: #FFFFFF;
		position: absolute;
		right: 30px;
		top: -10px;
	}
    .seeBtnBoxNo {
        color: #00AFB5;
        border: 1px solid #00AFB5;
        border-radius: 4px;
        font-size: 14px;
        padding: 5px 20px;
    }
    .seeBtnBox {
        background: #00AFB5;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
        padding: 5px 20px;
    }
    .boxtagBox {
		display: flex;
		align-items: center;
		margin: 15px 0;
		width: 40%;
		margin: auto;
		background: #EBF3F5;
		border-radius: 16rpx;
		padding: 5px;
	}
    .boxtag {
		width: 50%;
		text-align: center;
		padding: 10px 0;
	}
	.boxtagCheck {
		width: 50%;
		text-align: center;
		padding: 10px 0;
		background: #FFFFFF;
		border-radius: 5px;
	}
    .numTag1 {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: #E63838;
		color: #FFFFFF;
		position: absolute;
		right: 30px;
		top: 5px;
	}
</style>
